<template>
	<DsNavService
		:items="vm.baseViewModel.items"
		:aria-label="vm.baseViewModel.ariaLabel"
		@service-click="handleServiceClick"
	>
		<slot />
	</DsNavService>
</template>

<script setup lang="ts">
import { DsNavService } from '@coloplast/design-system';
import { useServiceNavigationClick } from 'shared/composables/useServiceNavigationClick';
import type {
	GlobalServiceNavigationProps
} from './GlobalServiceNavigation.types';

defineProps<GlobalServiceNavigationProps>();
const { handleServiceClick } = useServiceNavigationClick();
</script>
